import type { FirebaseError } from 'firebase/app'
import {
  browserSessionPersistence,
  sendPasswordResetEmail,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
  User,
} from 'firebase/auth'

import type { LoginPayload } from '@/features/auth/types'
import type { Response as Res } from '@/shared/types/response'
import { auth } from '@/core/firebase'
import { useCompanyStore } from '@/features/companies'

const authServices = {
  async signIn({ email, password }: LoginPayload): Promise<Res<User>> {
    try {
      await setPersistence(auth, browserSessionPersistence)
      const { user } = await signInWithEmailAndPassword(auth, email, password)
      return { data: user, ok: true, message: 'Login realizado com sucesso' }
    } catch (exception) {
      const error = exception as FirebaseError
      const isInvalidPayload = error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password'
      return {
        data: null,
        ok: false,
        message: isInvalidPayload ? 'E-mail ou senha inválidos' : 'Não foi possível realizar o login',
      }
    }
  },

  async signOut(): Promise<Res<undefined>> {
    try {
      await signOut(auth)
      const { cleanCompanies } = useCompanyStore()
      cleanCompanies()
      return { data: undefined, ok: true, message: 'Logout realizado com sucesso' }
    } catch (exception) {
      return { data: null, ok: false, message: 'Não foi possível realizar o logout' }
    }
  },

  async sendPasswordResetEmail(email: string): Promise<Res<undefined>> {
    try {
      await sendPasswordResetEmail(auth, email)
      return { data: undefined, ok: true, message: 'E-mail de recuperação de senha enviado com sucesso' }
    } catch (exception) {
      return { data: null, ok: false, message: 'Não foi possível enviar o e-mail de recuperação de senha' }
    }
  },
}

export default authServices
